var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t工资明细表-补充")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目",
      "prop": "organize_temporary_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.ruleForm.organize_temporary_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_temporary_ids", $$v)
      },
      expression: "ruleForm.organize_temporary_ids"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间",
      "prop": "years_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.ruleForm.years_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "years_date", $$v)
      },
      expression: "ruleForm.years_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "staff_ids"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.name
    },
    model: {
      value: (_vm.ruleForm.staff_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_ids", $$v)
      },
      expression: "ruleForm.staff_ids"
    }
  }, _vm._l((_vm.yglist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.staff_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位",
      "prop": "post_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.post_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "post_name", $$v)
      },
      expression: "ruleForm.post_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工资总额",
      "prop": "total_wages"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入工资总额"
    },
    model: {
      value: (_vm.ruleForm.total_wages),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "total_wages", $$v)
      },
      expression: "ruleForm.total_wages"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "基本工资",
      "prop": "base_pay"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入基本工资"
    },
    model: {
      value: (_vm.ruleForm.base_pay),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "base_pay", $$v)
      },
      expression: "ruleForm.base_pay"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位工资",
      "prop": "post_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入岗位工资"
    },
    model: {
      value: (_vm.ruleForm.post_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "post_salary", $$v)
      },
      expression: "ruleForm.post_salary"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "日工资",
      "prop": "daily_wage"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入日工资"
    },
    model: {
      value: (_vm.ruleForm.daily_wage),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "daily_wage", $$v)
      },
      expression: "ruleForm.daily_wage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应出勤天数",
      "prop": "days_attendance"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入应出勤天数"
    },
    model: {
      value: (_vm.ruleForm.days_attendance),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "days_attendance", $$v)
      },
      expression: "ruleForm.days_attendance"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "缺勤天数",
      "prop": "absence_days"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入缺勤天数"
    },
    model: {
      value: (_vm.ruleForm.absence_days),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "absence_days", $$v)
      },
      expression: "ruleForm.absence_days"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "缺勤扣款",
      "prop": "deduction_absence"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入缺勤扣款"
    },
    model: {
      value: (_vm.ruleForm.deduction_absence),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deduction_absence", $$v)
      },
      expression: "ruleForm.deduction_absence"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实出勤天数",
      "prop": "actual_attendance_days"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入实出勤天数"
    },
    model: {
      value: (_vm.ruleForm.actual_attendance_days),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "actual_attendance_days", $$v)
      },
      expression: "ruleForm.actual_attendance_days"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工资额",
      "prop": "wages"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入工资额"
    },
    model: {
      value: (_vm.ruleForm.wages),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wages", $$v)
      },
      expression: "ruleForm.wages"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "满勤",
      "prop": "full_work_attendance"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入满勤"
    },
    model: {
      value: (_vm.ruleForm.full_work_attendance),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "full_work_attendance", $$v)
      },
      expression: "ruleForm.full_work_attendance"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "餐补",
      "prop": "meal_supplement"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入餐补"
    },
    model: {
      value: (_vm.ruleForm.meal_supplement),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "meal_supplement", $$v)
      },
      expression: "ruleForm.meal_supplement"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加班时间",
      "prop": "overtime"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入加班时间"
    },
    model: {
      value: (_vm.ruleForm.overtime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overtime", $$v)
      },
      expression: "ruleForm.overtime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加班金额",
      "prop": "overtime_amount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入加班金额"
    },
    model: {
      value: (_vm.ruleForm.overtime_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overtime_amount", $$v)
      },
      expression: "ruleForm.overtime_amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "替班",
      "prop": "substitute"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入替班"
    },
    model: {
      value: (_vm.ruleForm.substitute),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "substitute", $$v)
      },
      expression: "ruleForm.substitute"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "话费",
      "prop": "telephone_charges"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入话费"
    },
    model: {
      value: (_vm.ruleForm.telephone_charges),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "telephone_charges", $$v)
      },
      expression: "ruleForm.telephone_charges"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代岗工资",
      "prop": "substitute_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入代岗工资"
    },
    model: {
      value: (_vm.ruleForm.substitute_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "substitute_salary", $$v)
      },
      expression: "ruleForm.substitute_salary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "弥补前期",
      "prop": "make_up_for_the_early_stage"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入弥补前期"
    },
    model: {
      value: (_vm.ruleForm.make_up_for_the_early_stage),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "make_up_for_the_early_stage", $$v)
      },
      expression: "ruleForm.make_up_for_the_early_stage"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖励",
      "prop": "reward"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入奖励"
    },
    model: {
      value: (_vm.ruleForm.reward),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reward", $$v)
      },
      expression: "ruleForm.reward"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "归还工服押金",
      "prop": "return_of_work_clothes_deposit"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入归还工服押金"
    },
    model: {
      value: (_vm.ruleForm.return_of_work_clothes_deposit),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "return_of_work_clothes_deposit", $$v)
      },
      expression: "ruleForm.return_of_work_clothes_deposit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "其他+",
      "prop": "other_plus"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入其他+"
    },
    model: {
      value: (_vm.ruleForm.other_plus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "other_plus", $$v)
      },
      expression: "ruleForm.other_plus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "迟到扣款",
      "prop": "late_deduction"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入迟到扣款"
    },
    model: {
      value: (_vm.ruleForm.late_deduction),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "late_deduction", $$v)
      },
      expression: "ruleForm.late_deduction"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "处罚扣款",
      "prop": "penalty_deduction"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入处罚扣款"
    },
    model: {
      value: (_vm.ruleForm.penalty_deduction),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "penalty_deduction", $$v)
      },
      expression: "ruleForm.penalty_deduction"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发放工服押金",
      "prop": "pay_the_work_clothes_deposit"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入发放工服押金"
    },
    model: {
      value: (_vm.ruleForm.pay_the_work_clothes_deposit),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "pay_the_work_clothes_deposit", $$v)
      },
      expression: "ruleForm.pay_the_work_clothes_deposit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "其他-",
      "prop": "other_reduce"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入其他-"
    },
    model: {
      value: (_vm.ruleForm.other_reduce),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "other_reduce", $$v)
      },
      expression: "ruleForm.other_reduce"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车补",
      "prop": "car_supplement"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入车补"
    },
    model: {
      value: (_vm.ruleForm.car_supplement),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "car_supplement", $$v)
      },
      expression: "ruleForm.car_supplement"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "驻外补助",
      "prop": "overseas_subsidies"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入驻外补助"
    },
    model: {
      value: (_vm.ruleForm.overseas_subsidies),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overseas_subsidies", $$v)
      },
      expression: "ruleForm.overseas_subsidies"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "其他补贴",
      "prop": "other_subsidies"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入其他补贴"
    },
    model: {
      value: (_vm.ruleForm.other_subsidies),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "other_subsidies", $$v)
      },
      expression: "ruleForm.other_subsidies"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应发补贴小计",
      "prop": "subtotal_of_subsidies_payable"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入应发补贴小计"
    },
    model: {
      value: (_vm.ruleForm.subtotal_of_subsidies_payable),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "subtotal_of_subsidies_payable", $$v)
      },
      expression: "ruleForm.subtotal_of_subsidies_payable"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实发补贴小计",
      "prop": "subtotal_of_subsidies_paid"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入实发补贴小计"
    },
    model: {
      value: (_vm.ruleForm.subtotal_of_subsidies_paid),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "subtotal_of_subsidies_paid", $$v)
      },
      expression: "ruleForm.subtotal_of_subsidies_paid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应发工资",
      "prop": "wages_payable"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入应发工资"
    },
    model: {
      value: (_vm.ruleForm.wages_payable),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wages_payable", $$v)
      },
      expression: "ruleForm.wages_payable"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "社保扣款",
      "prop": "social_security_deduction"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入社保扣款"
    },
    model: {
      value: (_vm.ruleForm.social_security_deduction),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "social_security_deduction", $$v)
      },
      expression: "ruleForm.social_security_deduction"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "意外保险",
      "prop": "accident_insurance"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入意外保险"
    },
    model: {
      value: (_vm.ruleForm.accident_insurance),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "accident_insurance", $$v)
      },
      expression: "ruleForm.accident_insurance"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公积金",
      "prop": "accumulation_fund"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入公积金"
    },
    model: {
      value: (_vm.ruleForm.accumulation_fund),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "accumulation_fund", $$v)
      },
      expression: "ruleForm.accumulation_fund"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实发工资（税前）",
      "prop": "before_tax_paid_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入实发工资（税前）"
    },
    model: {
      value: (_vm.ruleForm.before_tax_paid_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "before_tax_paid_salary", $$v)
      },
      expression: "ruleForm.before_tax_paid_salary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人所得税",
      "prop": "individual_income_tax"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入个人所得税"
    },
    model: {
      value: (_vm.ruleForm.individual_income_tax),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "individual_income_tax", $$v)
      },
      expression: "ruleForm.individual_income_tax"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实发工资（税后）",
      "prop": "after_tax_paid_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入实发工资（税后）"
    },
    model: {
      value: (_vm.ruleForm.after_tax_paid_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "after_tax_paid_salary", $$v)
      },
      expression: "ruleForm.after_tax_paid_salary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取方式",
      "prop": "receiving_method"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择领取方式"
    },
    model: {
      value: (_vm.ruleForm.receiving_method),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "receiving_method", $$v)
      },
      expression: "ruleForm.receiving_method"
    }
  }, _vm._l((_vm.lqList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''),
      expression: "this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''"
    }],
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡号",
      "prop": "bank_card_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "disabled": true,
      "placeholder": " "
    },
    model: {
      value: (_vm.ruleForm.bank_card_number),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bank_card_number", $$v)
      },
      expression: "ruleForm.bank_card_number"
    }
  })], 1)], 1), _vm._v(" "), (this.ruleForm.receiving_method == '代发') ? _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡号",
      "prop": "bank_card_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": " "
    },
    model: {
      value: (_vm.ruleForm.bank_card_number),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "bank_card_number", $$v)
      },
      expression: "ruleForm.bank_card_number"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.ruleForm.receiving_method == '代发'),
      expression: "this.ruleForm.receiving_method == '代发'"
    }],
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "持卡人姓名",
      "prop": "cardholder_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.cardholder_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cardholder_name", $$v)
      },
      expression: "ruleForm.cardholder_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择持卡人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''),
      expression: "this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''"
    }],
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "持卡人姓名",
      "prop": "entry_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.cardholder_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "cardholder_name", $$v)
      },
      expression: "ruleForm.cardholder_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "entry_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.entry_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "entry_name", $$v)
      },
      expression: "ruleForm.entry_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "id_card"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.id_card),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "id_card", $$v)
      },
      expression: "ruleForm.id_card"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话号",
      "prop": "telephone_number"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.telephone_number),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "telephone_number", $$v)
      },
      expression: "ruleForm.telephone_number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": " ",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gender", $$v)
      },
      expression: "ruleForm.gender"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.AddAuditor
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5a22d20","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/GzmxBc/GzmxBc.vue
// module id = null
// module chunks = 